module.exports = __webpack_public_path__ + "img/qr.4ad72090.svg";